
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprehensive-search-report",
      function () {
        return require("private-next-pages/comprehensive-search-report.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comprehensive-search-report"])
      });
    }
  